
// src/reducers/submission-schedules-reducer.js

import {
  SAVE_SUBMISSION_SCHEDULES,
  SAVE_SUBMISSION_SCHEDULES_REQUESTED,
  SAVE_SUBMISSION_SCHEDULES_COMPLETED,
  SAVE_SUBMISSION_SCHEDULES_FAILED,
} from '../actions/submission-schedules'

const initialState = {
  isSaving: false,
  isSaveFailed: false,
}

export default function submissionSchedulesReducer(state = initialState, action = {}) {
  switch(action.type) {
    case SAVE_SUBMISSION_SCHEDULES_REQUESTED:
      return Object.assign({}, state, {
        isSaving: true,
        isSaveFailed: false,
      })

    case SAVE_SUBMISSION_SCHEDULES_COMPLETED:
      return Object.assign({}, state, {
        isSaving: false,
        isSaveFailed: false,
        schedules: action.results,
      })

    case SAVE_SUBMISSION_SCHEDULES_FAILED:
      return Object.assign({}, state, {
        isSaving: false,
        isSaveFailed: true,
      })

    default:
    return state  
  }
}



// WEBPACK FOOTER //
// ./src/reducers/submission-schedules-reducer.js